import { useMemo } from 'react';
import { Map as ImmutableMap } from 'immutable';
import { ReportingILSStrategyBuilder } from 'customer-data-filters-ui/public/strategies';
import PropertyRecord from 'customer-data-objects/property/PropertyRecord';
import { toDSFieldRecord } from 'customer-data-filters-ui/public/core';
// @ts-expect-error untyped
import { getReferenceTypeForObjectTypeId } from 'reporting-snowflake/relational/metadata/references/external/external-mapping';
const propertiesWithOverrides = {
  hs_marketing_event: 'MARKETING_EVENT_COORDINATES',
  hs_web_interactive_coordinates: 'WEB_INTERACTIVE_COORDINATES'
};
function getPropertyOverrides(property) {
  if (property.type === 'object_coordinates') {
    const override = propertiesWithOverrides[property.name];
    if (override) {
      return {
        externalOptions: false,
        externalOptionsReferenceType: undefined,
        referencedObjectType: override
      };
    }
  }
  return {};
}
export const useBuildJourneyFilterStrategy = ({
  properties,
  dataType
}) => {
  const strategy = useMemo(() => {
    if (Object.keys(properties).length === 0) {
      return undefined;
    }
    let propertiesMap = ImmutableMap({});
    Object.keys(properties).forEach(key => {
      var _properties$key, _properties$key2;
      const property = (_properties$key = properties[key]) === null || _properties$key === void 0 ? void 0 : _properties$key.propertyDefinition.property;
      const propertyObjectTypeId = (_properties$key2 = properties[key]) === null || _properties$key2 === void 0 ? void 0 : _properties$key2.propertyDefinition.objectTypeId;
      const referenceType = getReferenceTypeForObjectTypeId(Object.assign({}, property, {
        objectTypeId: propertyObjectTypeId
      }));
      if (property) {
        const newProp = PropertyRecord.fromJS(!referenceType || property.externalOptionsReferenceType ? property : Object.assign({}, property, {
          externalOptions: true,
          externalOptionsReferenceType: referenceType
        }, getPropertyOverrides(property)));
        propertiesMap = propertiesMap.set(key, newProp);
      }
    });

    // Convert to correct DSFieldRecordType
    const updatedProps = toDSFieldRecord(propertiesMap, dataType, 'PROPERTY_RECORD');
    return ReportingILSStrategyBuilder({
      getField: (_, id, originalField) => updatedProps.get(id) || originalField,
      getFields: () => updatedProps,
      getFilterFamilyName: () => dataType,
      getFilterFamilyObjectName: () => dataType,
      reportingFilterContext: 'snowflake_object'
    });
  }, [properties, dataType]);
  return strategy;
};